import PageLayout from "Layouts/PageLayout";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import {useDeleteTag, useTag} from "../../Apis/TagApi";
import { TagForm } from "Features/Tags";
import TagIcon from "Assets/SVG/TagIcon";
import XIcon from "../../Assets/SVG/XIcon";
import Button from "../../Components/Button";

const Edit = () => {
    
    const { t } = useTranslation();
    
    const { id } = useParams();
    
    const { data: tag } = useTag(parseInt(id!));
    
    const { mutateAsync: deleteTagMutation, isLoading: isDeletingTag } = useDeleteTag();
    
    const navigate = useNavigate();

    const deleteTag = async () => {
        await deleteTagMutation(tag!);

        navigate(-1)
    }
    
    return (
        <PageLayout title={t('updateTag')} icon={<TagIcon />} includeBox header={(
            <Button type={"secondary"} loading={isDeletingTag} prefix={<XIcon fill={"#FFF"} />} text={t('deletePartner')} onClick={deleteTag} />
        )}>
            <TagForm tag={tag} onSubmit={_ => navigate(-1)} />
        </PageLayout>
    )
}

export default Edit;
